export const FETCH_POIS = "pois/FETCH_POIS";
export const SET_POIS = "pois/SET_POIS";
export const SET_POI = "pois/SET_POI";
export const SET_HOVERED_POI_ID = "pois/SET_HOVERED_POI_ID";
